import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import api from '@/api';
import ButtonDialog from '@/components/ButtonDialog.vue';
import LeftGroupList from '@/components/LeftGroupList.vue';
import OpticalPathBoard from '@/components/subject/OpticalPathInference/OpticalPathBoard.vue';
import OpticalPathQuestionConfigurator from '@/components/subject/OpticalPathInference/OpticalPathQuestionConfigurator.vue';
export default {
  name: 'OpticalPathQuestionView',
  components: {
    ButtonDialog,
    LeftGroupList,
    OpticalPathBoard,
    OpticalPathQuestionConfigurator
  },
  data() {
    return {
      groups: [],
      groupId: null,
      questions: [],
      total: 0,
      page: 0,
      pageSize: 20,
      loading: false,
      editorVisible: false,
      editingQuestion: null
    };
  },
  computed: {
    currentGroupName() {
      return this.groups.find(group => group.value === this.groupId)?.text || '';
    }
  },
  methods: {
    parseImages(value) {
      if (Array.isArray(value)) return value;
      if (!value) return [];
      try {
        return JSON.parse(value);
      } catch (e) {
        return [];
      }
    },
    parseConfig(value) {
      if (!value) return null;
      try {
        return typeof value === 'string' ? JSON.parse(value) : value;
      } catch (e) {
        return null;
      }
    },
    elementCount(config) {
      return config?.layout?.cells?.filter(Boolean).length || 0;
    },
    openEditor(question = null) {
      this.editingQuestion = question;
      this.editorVisible = true;
    },
    onChoose(groupId) {
      this.groupId = groupId;
      this.page = 0;
      this.fetchQuestions();
    },
    fetchQuestions() {
      if (!this.groupId) {
        this.questions = [];
        this.total = 0;
        return;
      }
      this.loading = true;
      api.getOpticalPathQuestions({
        groupId: this.groupId,
        page: this.page,
        pageSize: this.pageSize
      }).then(result => {
        this.questions = result.list.map(question => ({
          ...question,
          _opticalConfig: this.parseConfig(question.opticalConfig)
        }));
        this.total = result.total;
      }).finally(() => {
        this.loading = false;
      });
    },
    toggleEnabled(question, enabled) {
      api.toggleOpticalPathQuestion({
        id: question.id,
        enabled
      }).then(() => {
        question.enabled = enabled;
      });
    },
    deleteQuestion(id) {
      api.deleteOpticalPathQuestion(id).then(this.fetchQuestions);
    },
    deleteGroup() {
      api.deleteOpticalPathGroup(this.groupId).then(this.init);
    },
    init() {
      api.getOpticalPathGroups().then(groups => {
        this.groups = groups;
        this.groupId = groups.length ? groups[0].value : null;
        this.page = 0;
        this.fetchQuestions();
      });
    }
  },
  mounted() {
    this.init();
  }
};